'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('complete_streets', {
      url: '/account/stationaccess/complete_streets?jurisdiction&sta_recid&policyName',
      template: '<complete-streets></complete-streets>',
      authenticate: true,
      params: {
        jurisdiction: null,  // Default value if not provided
        sta_recid: null,     // Default value if not provided
        policyName: null     // Default value if not provided
      }
    });
}



// WEBPACK FOOTER //
// ./client/app/account/stationaccess/complete_streets/complete_streets.routes.js